// components/Report/ReportFormat.js
import React, { useMemo } from 'react';
import ReportFormatFour from '../Academics/Reports/Templates/ReportFormatFour';
import ReportFormaTwo from '../Academics/Reports/Templates/ReportFormaTwo';
import ReportFormaThree from '../Academics/Reports/Templates/ReportFormaThree';
import ReportFormatOne from '../Academics/Reports/Templates/ReportFormatOne';

const ReportFormat = ({ reportInfo, student, studentId, initials, totalStudents, final=false }) => {
  const CurrentFormat = useMemo(() => {
    const formatId = reportInfo?.report_format?.format_id * 1;
    switch (formatId) {
      case 5:
        return ReportFormatFour;
      case 4:
        return ReportFormaTwo;
      case 2:
        return ReportFormaThree;
      default:
        return ReportFormatOne;
    }
  }, [reportInfo]);

  return (
    <CurrentFormat
      student={student}
      studentId={studentId}
      reportInfo={reportInfo}
      initials={initials}
      totalStudents={totalStudents}
      final={final}
    />
  );
};

export default ReportFormat;
